import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import RichText from '../controls/RichText';
import { useForceUpdate, numberToLetter, getRawText } from '../util';
import { HotspotEditor } from './TaskCallout';
import { TabContextReporter } from '../TabContext';
import Dropdown from 'react-bootstrap/Dropdown';
import NeutralToggle from '../controls/NeutralToggle';
import { FormValidityProvider, FormValidityReporter } from '../FormValidity';
export default function TaskImageClick(props) {
  const forceUpdate = useForceUpdate();
  const dataProps = props.data.props;
  const hotspots = dataProps.hotspots;
  const picture = dataProps.picture;
  const [activeKey, setActiveKey] = React.useState(null);
  const hs = hotspots[activeKey];
  const perc = x => parseInt(x) / 5.40 + "%";
  const ltwh = ["left", "top", "width", "height"];
  return /*#__PURE__*/React.createElement(FormValidityProvider, {
    onChange: props.onValidityChange
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: 0,
    title: "General information"
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Image URL:"), " ", /*#__PURE__*/React.createElement("i", null, "A direct link to the image.")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.picture,
    onChange: e => {
      dataProps.picture = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Alt Text:"), " ", /*#__PURE__*/React.createElement("i", null, "A literal description of the image.")), /*#__PURE__*/React.createElement(Form.Control, {
    as: "textarea",
    value: dataProps.alt,
    onChange: e => {
      dataProps.alt = e.target.value;
      forceUpdate();
      props.onChanged();
    }
  }), /*#__PURE__*/React.createElement(FormValidityReporter, {
    valid: getRawText(dataProps.alt || "").length > 0
  }, "Please enter alt text.")), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Caption:"), " ", /*#__PURE__*/React.createElement("i", null, "A figurative description of the image.")), /*#__PURE__*/React.createElement(RichText, {
    key: "multiselect-correct",
    value: dataProps.details,
    onChange: v => {
      dataProps.details = v;
      forceUpdate();
      props.onChanged();
    }
  })), /*#__PURE__*/React.createElement(Button, {
    block: true,
    variant: "success",
    onClick: () => {
      hotspots.push({
        correct: [0],
        label: "Hotspot " + numberToLetter(hotspots.length),
        style: {
          top: "0px",
          left: "0px",
          width: "50px",
          height: "50px"
        },
        shape: "Square"
      });
      props.triggerStateUpdate();
      forceUpdate();
      props.onChanged();
    }
  }, "Add New Hotspot")), hotspots.map((hotspot, i) => {
    const letter = numberToLetter(i);
    return /*#__PURE__*/React.createElement(TabContextReporter, {
      index: i + 1,
      title: hotspot.label
    }, /*#__PURE__*/React.createElement(HotspotEditor, {
      hs: hotspots[i],
      picture: picture,
      forceUpdate: forceUpdate,
      onChanged: props.onChanged,
      triggerStateUpdate: props.triggerStateUpdate
    }), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Label:"), " ", /*#__PURE__*/React.createElement("i", null, "A literal description of the area covered by the hotspot.")), /*#__PURE__*/React.createElement(Form.Control, {
      as: "textarea",
      value: hotspot.label,
      onChange: e => {
        hotspot.label = e.target.value;
        forceUpdate();
        props.onChanged();
      }
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Hotspot Shape:")), /*#__PURE__*/React.createElement(Dropdown, {
      className: "mx-2"
    }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
      id: "dropdown-basic"
    }, hotspots[i].shape), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
      onClick: e => {
        hotspots[i].shape = "Square";
        forceUpdate();
        props.onChanged();
        props.triggerStateUpdate();
      }
    }, "Square"), /*#__PURE__*/React.createElement(Dropdown.Item, {
      onClick: e => {
        hotspots[i].shape = "Circle";
        forceUpdate();
        props.onChanged();
        props.triggerStateUpdate();
      }
    }, "Circle")))), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Correct:")), /*#__PURE__*/React.createElement(NeutralToggle, {
      style: {
        display: 'block'
      },
      optionTrue: "Correct",
      optionFalse: "Incorrect",
      value: hotspot.correct,
      onChange: v => {
        hotspot.correct = v;
        forceUpdate();
        props.onChanged();
      }
    })), /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "Feedback:"), " ", /*#__PURE__*/React.createElement("i", null, "Starts with \"Correct!\" or \"Incorrect.\"")), /*#__PURE__*/React.createElement(RichText, {
      key: "multiselect-correct",
      value: hotspot.feedback,
      onChange: v => {
        hotspot.feedback = v;
        forceUpdate();
        props.onChanged();
      }
    })), /*#__PURE__*/React.createElement(Button, {
      block: true,
      variant: "danger",
      onClick: () => {
        hotspots.splice(i, 1);
        props.triggerStateUpdate();
        props.decrementActiveTab();
        props.onChanged();
      }
    }, "Remove Hotspot"));
  })));
}